import { jsx as q } from "react/jsx-runtime";
import { c as u } from "./clsx-OuTLNxxd.js";
import "./button.types-BqgkEc5r.js";
import "./components/elements/button/iconButton/iconButton.js";
const h = "_box_6yjql_29", j = "_small_6yjql_40", p = "_medium_6yjql_48", s = {
  box: h,
  "has-border": "_has-border_6yjql_37",
  small: j,
  medium: p,
  "has-actions": "_has-actions_6yjql_56",
  "full-height": "_full-height_6yjql_67",
  "full-width": "_full-width_6yjql_70",
  "is-primary": "_is-primary_6yjql_73",
  "is-secondary": "_is-secondary_6yjql_77",
  "is-tertiary": "_is-tertiary_6yjql_81",
  "is-clickable": "_is-clickable_6yjql_85",
  "is-square": "_is-square_6yjql_88",
  "is-centered": "_is-centered_6yjql_91",
  "box-actions": "_box-actions_6yjql_98",
  "dialog-overlay-show": "_dialog-overlay-show_6yjql_1",
  "dialog-content-show": "_dialog-content-show_6yjql_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_6yjql_1"
};
function v({
  children: a,
  size: l = "medium",
  color: t = "primary",
  className: _ = "",
  isFullHeight: e,
  isFullWidth: r,
  border: y = !0,
  onClick: i,
  isCentered: n,
  isSquare: c,
  ...d
}) {
  const m = u(
    s.box,
    s[l],
    _,
    e && s["full-height"],
    r && s["full-width"],
    y && s["has-border"],
    s[b[t]],
    i && s["is-clickable"],
    n && s["is-centered"],
    c && s["is-square"]
  );
  return /* @__PURE__ */ q(
    "div",
    {
      className: m,
      onClick: (o) => {
        i && (o.stopPropagation(), i());
      },
      onKeyDown: (o) => {
        i && o.key === "Enter" && (o.stopPropagation(), i());
      },
      ...i && {
        role: "button",
        tabIndex: 0
      },
      ...d,
      children: a
    }
  );
}
const b = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
};
export {
  v as B,
  b as a,
  s
};
